import React, { useCallback } from 'react'
import List from '@commonComponents/List'
import PreviousDocForm from '@EUForms/previousDocForm'
import { useSelector } from 'react-redux'
import { selectPreviousDocTypeList } from '@EUForms/selectors'
import CopyRepElement from '@commonComponents/copyRepElement'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'
import MarkedDeleted from '../markedDeleted'

const PreviousDocDetail = (props) => {
  const { 
    dataSource, 
    isMerchandiseDisabled, 
    onMarkMerchandiseDocDelete, 
    ...rest 
  } = props
  const dropdownList = useSelector(selectPreviousDocTypeList)
  const {isDisabled, isRFI, isRFIDisabled} = useCurrentShipmentType()
  const renderItem = useCallback(
    (item) => {
      const isPreviousDocDisabled = (isMerchandiseDisabled||(isRFI&&item?.markDelete=='1')||null) 
      return(
      <PreviousDocForm 
        dataSource={item} 
        key={item.id} 
        docTypeList={dropdownList} 
        copyDocument={(translate) => (<CopyRepElement
          translate={translate}
          title='PREVIOUS_DOCUMENT'
          request={{...item,infoType:'EU_PREVIOUS_DOCUMENT'}}
          callback={rest?.copyData}
          isFormDisabled={isRFI||isPreviousDocDisabled||isDisabled}
          tableName={rest?.tableName}
        />)}
        {...rest} 
        isPreviousDocDisabled={isPreviousDocDisabled}
        markedDeleted={isRFI?(params) => <MarkedDeleted
          label='_'
          className='marked-deleted marked-deleted-label-hidden'
          disabled={(isRFIDisabled||isMerchandiseDisabled)}
          checked={(isPreviousDocDisabled||false)}
          onChange={
            (e, data) => onMarkMerchandiseDocDelete(data, params)
          }
        />:null}
      />
      )},
    [dropdownList, isMerchandiseDisabled, rest]
  )

  return <List className='responsiveGridCss' dataSource={dataSource} renderItem={renderItem} />
}

export default React.memo(PreviousDocDetail)
